/* ============================================================
   HDT Hero Image — Scroll Effects JS
   Separated from hero-image.liquid for cleaner asset management.

   Data attributes read from the <script> tag itself:
     data-section-id      → matches #Image-{id}
     data-scroll-effect   → zoom-in | zoom-out | slide-left |
                            slide-right | rotate | content-parallax | none
     data-scroll-fade-out → true | false
     data-scroll-speed    → numeric (0–1 range, already divided by 100)
   ============================================================ */

(function () {
  'use strict';

  function initHeroScroll(scriptTag) {
    var sectionId   = scriptTag.getAttribute('data-section-id');
    var scrollEffect   = scriptTag.getAttribute('data-scroll-effect')   || 'none';
    var scrollFadeOut  = scriptTag.getAttribute('data-scroll-fade-out') === 'true';
    var scrollSpeed    = parseFloat(scriptTag.getAttribute('data-scroll-speed')) || 0.5;

    if (scrollEffect === 'none' && !scrollFadeOut) return;

    var el = document.getElementById('Image-' + sectionId);
    if (!el) return;

    var ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    function update() {
      ticking = false;
      var rect    = el.getBoundingClientRect();
      var scrolled = -rect.top;
      if (scrolled < 0) return;

      var progress = scrolled / (rect.height || 1);
      var img;

      /* --- scroll-zoom-in --- */
      if (scrollEffect === 'zoom-in') {
        var scale = 1 + progress * scrollSpeed * 0.4;
        img = el.querySelector('picture img, .hdt-media-wrapper img, .hdt-media-wrapper svg');
        if (img) img.style.transform = 'scale(' + scale + ')';
      }

      /* --- scroll-zoom-out --- */
      if (scrollEffect === 'zoom-out') {
        var scaleOut = Math.max(0.85, 1 - progress * scrollSpeed * 0.15);
        img = el.querySelector('picture img, .hdt-media-wrapper img, .hdt-media-wrapper svg');
        if (img) img.style.transform = 'scale(' + scaleOut + ')';
      }

      /* --- scroll-slide-left / slide-right --- */
      if (scrollEffect === 'slide-left' || scrollEffect === 'slide-right') {
        var dir = scrollEffect === 'slide-left' ? -1 : 1;
        var tx  = dir * progress * scrollSpeed * 60;
        img = el.querySelector('picture img, .hdt-media-wrapper img, .hdt-media-wrapper svg');
        if (img) img.style.transform = 'translateX(' + tx + 'px)';
      }

      /* --- scroll-rotate --- */
      if (scrollEffect === 'rotate') {
        var deg = progress * scrollSpeed * 8;
        img = el.querySelector('picture img, .hdt-media-wrapper img, .hdt-media-wrapper svg');
        if (img) img.style.transform = 'rotate(' + deg + 'deg) scale(1.1)';
      }

      /* --- content parallax offset --- */
      if (scrollEffect === 'content-parallax') {
        var contentWrap = el.querySelector('.hdt-hero-image__content-wrap');
        if (contentWrap) {
          var ty = scrolled * scrollSpeed * -0.35;
          contentWrap.style.transform = 'translateY(' + ty + 'px)';
        }
      }

      /* --- fade out on scroll --- */
      if (scrollFadeOut) {
        var opacity    = Math.max(0, 1 - progress * 2);
        var contentBox = el.querySelector('.hdt-hero-image__content-box');
        if (contentBox) contentBox.style.opacity = opacity;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update(); // run once on load in case page is already scrolled
  }

  /* Find the script tag that loaded this file and init */
  document.querySelectorAll('script[data-section-id][data-scroll-effect]').forEach(initHeroScroll);

})();
